import React from 'react';
import { BoardMotif } from './BoardMotif';
type Tome = {
  number: string;
  title: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Prepare',
  promise: 'Screening, consent, room and music setup, and your first sessions with a new breather — the base of the whole pack.',
  badge: 'bg-sage',
  contents: ['The Breath Arc Method and the Green-Amber-Red Screen', 'The Consent Ladder: touch, sound and depth agreed before you need them', 'First Session: Meeting the Breath, and what changes by session 3', '30 rhythm and encouragement cues, ready to say', '21 Breath Cards + 7 worksheets']
}, {
  number: '02',
  title: 'Breathe',
  promise: 'Themed 1:1 sessions and how to meet what arises — ready to run from intention to integration.',
  badge: 'bg-teal-deep',
  contents: ['The Wave Read: build, crest, release, still', 'The Pace Dial: when to move between Gentle, Steady and Full', '15 themed sessions: letting go, life transitions, boundaries, courage and more', 'Lines for tears, strong energy, laughter, voice, movement and touch with consent', '28 Breath Cards + 3 worksheets']
}, {
  number: '03',
  title: 'Integrate',
  promise: 'Integration practices and session series that help every session land.',
  badge: 'bg-terra-deep',
  contents: ['The Landing Sequence: Notice, Name, Anchor, Act', 'The 7-Day Thread: one small home practice per day', 'The Series Arc: 3, 6 and 10-session journeys', '40 integration questions sorted by theme, plus a referral note template', '24 Breath Cards + 6 worksheets']
}, {
  number: '04',
  title: 'Circles',
  promise: 'Group breathwork circles ready to run, from the opening round to the closing ritual.',
  badge: 'bg-ochre-deep',
  contents: ['The Circle Container: Open, Agree, Breathe, Share, Seal', 'The Sitter System and the Room Read', '10 themed circles and a 12-month circle calendar', 'Room setups for 6, 12 and 20 breathers', '23 Breath Cards + 6 worksheets']
}, {
  number: '05',
  title: 'Workshops',
  promise: 'Two-hour, half-day and full-day breathwork workshops with minute-by-minute run sheets.',
  badge: 'bg-sage-mid',
  contents: ['The Workshop Spine: Teach, Taste, Breathe, Integrate, Take Home', 'The Room Energy Map for a full day', 'Ready-to-book workshops, from a 45-minute taster to a full-day immersion', 'Pairings with sound, gentle yoga, art and the outdoors', '23 Breath Cards + 6 worksheets']
}, {
  number: '06',
  title: 'Retreats & Online',
  promise: 'Multi-day retreat arcs and online sessions, one-to-one and in groups.',
  badge: 'bg-ink',
  contents: ['The Retreat Breath Curve: intensity day by day', 'Weekend and 5-day retreat planners', 'The Remote Safety Protocol for every online session', 'Online 1:1s, online circles, membership sessions and hybrid rooms', '20 Breath Cards + 10 worksheets']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-cream" data-id="element-252" data-mp="16lfzv2qnveix">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-253" data-mp="1akyly1u7xvnc">
        <div className="text-center" data-id="element-254" data-mp="dw95mfy8pb3h">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-255" data-mp="dxaecdrs9li1">
            The complete library
          </p>
          <h2 id="tomes-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-256" data-mp="ispr12e21bcv">
            Inside the library — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-257" data-mp="3ravops6bkt5x">
            They follow your work from the smallest room to the biggest:
            preparation, 1:1 sessions, integration, circles, workshops,
            retreats and online. Each volume stands on its own, with its own
            session formula, a safety page and a printable field card.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-258" data-mp="376y7uuoj9mch">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-sand-dark bg-white shadow-card" data-id="element-259" data-mp="3h6you9yxjqdi">
              <div className={`relative overflow-hidden ${tome.badge}`} data-id="element-260" data-mp="3v06jybm7z3zy">
                <BoardMotif className="pointer-events-none absolute -right-5 -top-6 h-24 w-24 text-white/20" data-id="element-261" data-mp="3pyqwye0henex" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-262" data-mp="8qdotioa07mj">
                  <span className="text-xs font-bold uppercase tracking-[2px] text-white/90" data-id="element-263" data-mp="3slqo6x1fp9w">
                    Volume {tome.number}
                  </span>
                  <span className="font-display text-3xl leading-none text-white" data-id="element-264" data-mp="25jyuesn9rr4d">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6 pt-5" data-id="element-265" data-mp="q07x70gdbcv1">
                <h3 className="font-display text-xl leading-snug text-sage" data-id="element-266" data-mp="pzoaz7joq2b7">
                  {tome.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-267" data-mp="gaob7lxcz2vy">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-sand-dark pt-4" data-id="element-268" data-mp="g8lao7ykxrcz">
                  {tome.contents.map((item, i) => <li key={item} className={`flex gap-2.5 text-[13px] ${i === tome.contents.length - 1 ? 'font-bold text-sage' : 'text-ink'}`} data-id="element-269" data-mp="6d04dxmha4xf" data-mpi={i}>
                      <span className="mt-[5px] h-2 w-2 flex-none rounded-full border-2 border-terra" data-id="element-270" data-mp="1mqgtscy068go" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}